import { performRequest } from '@celito.clients/network';

import Endpoints from '../config/endpoint';
import { ApiMethodType } from '../enums/api-constants';

export const downloadObjectTemplateFile = async (
  objectName: string,
  templateName: string
) => {
  const response = await performRequest<{ data: Buffer }>(
    `${Endpoints.OBJECT_URL}/${objectName}/templates/${templateName}/download`,
    ApiMethodType.GET,
    null,
    {}
  );
  return response.data;
};
